import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import * as styles from './styles';

export default ({ isOpen, closeModal, i18n, goBack }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={closeModal}
    style={styles.customStyles}
    contentLabel="Example Modal"
  >
    <styles.ModalCloseIcon onClick={closeModal} />
    <styles.ModalTitle>{i18n.t('go_back_title')}</styles.ModalTitle>
    <styles.ModalText>{i18n.t('go_back_text')}</styles.ModalText>
    <styles.ModalLine />
    <div style={{ position: 'relative', textAlign: 'right' }}>
      <styles.ModalCancel onClick={closeModal}>
        {i18n.t('cancel')}
      </styles.ModalCancel>
      <Link
        to=""
        onClick={e => {
          e.preventDefault();
          closeModal();
          goBack();
        }}
      >
        {' '}
        <styles.ModalButtonBack>
          {i18n.t('go_back')}
        </styles.ModalButtonBack>{' '}
      </Link>
    </div>
  </Modal>
);
